import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.boundResetScroll = this.resetScroll.bind(this)
    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener("turbo:frame-load", this.boundResetScroll)
    }
  }

  disconnect() {
    if (this.hasFrameTarget) {
      this.frameTarget.removeEventListener("turbo:frame-load", this.boundResetScroll)
    }
  }

  resetScroll() {
    this.element.closest(".roadmap-modal-dialog")?.scrollTo(0, 0)
  }

  close() {
    if (this.hasFrameTarget) {
      this.frameTarget.innerHTML = ""
    }
  }

  handleKeydown(event) {
    if (!this.hasFrameTarget || this.frameTarget.innerHTML.trim() === "") return

    if (event.key === "Escape") {
      this.close()
      return
    }

    const panel = this.frameTarget.querySelector(".roadmap-drawer-panel")
    if (!panel) return

    if (event.key === "ArrowLeft") {
      const url = panel.dataset.drawerPrevUrl
      if (url) {
        event.preventDefault()
        Turbo.visit(url, { frame: "item_drawer" })
      }
      return
    }

    if (event.key === "ArrowRight") {
      const url = panel.dataset.drawerNextUrl
      if (url) {
        event.preventDefault()
        Turbo.visit(url, { frame: "item_drawer" })
      }
    }
  }
}
